export const WAGE_FORMAT_TITLE = {
  'hourly': 'Hourly',
  'salary': 'Salary',
}